import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useCurrentUser } from '@/hooks/useCurrentUser';
import { LoginArea } from '@/components/auth/LoginArea';
import { Button } from '@/components/ui/button';
import { Zap, Plus } from 'lucide-react';

export function Header() {
  const { user } = useCurrentUser();

  return (
    <motion.header
      initial={{ y: -100, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.6, ease: 'easeOut' }}
      className="sticky top-0 z-50 border-b-2 border-orange-500/20 bg-white/95 backdrop-blur-xl shadow-lg"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16 sm:h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-2 sm:gap-3 group">
            <motion.div
              whileHover={{ rotate: 15, scale: 1.15 }}
              transition={{ type: 'spring', stiffness: 400 }}
              className="relative"
            >
              <Zap className="h-7 sm:h-9 w-7 sm:w-9 text-orange-600 drop-shadow-lg" fill="currentColor" />
            </motion.div>
            <span className="text-xl sm:text-2xl font-black bg-gradient-to-r from-orange-600 to-orange-500 bg-clip-text text-transparent">
              ZapFunder
            </span>
          </Link>

          {/* Actions */}
          <div className="flex items-center gap-2 sm:gap-4">
            {user && (
              <Link to="/create">
                <Button
                  size="lg"
                  className="bg-gradient-to-r from-orange-600 to-orange-500 hover:from-orange-700 hover:to-orange-600 text-white font-bold shadow-lg h-10 sm:h-11 px-3 sm:px-4"
                >
                  <Plus className="h-4 sm:h-5 w-4 sm:w-5 sm:mr-2" />
                  <span className="hidden sm:inline">Create</span>
                </Button>
              </Link>
            )}
            <LoginArea className="max-w-[180px] sm:max-w-[220px]" />
          </div>
        </div>
      </div>
    </motion.header>
  );
}
